import type { RootState } from 'store';

export const getUser = (state: RootState) => state.authorize.user;
export const getPermissionAssigned = (state: RootState) => state.authorize.permissionAssigned;
